<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="6" :lg="6" :md="12" :sm="12" :xs="24" class="margin-bottom">
          <Input v-model="params.name" placeholder="企业名称"></Input>
        </Col>
        <Col span="6" :lg="6" :md="12" :sm="12" :xs="24" class="margin-bottom">
          <Input v-model="params.code" placeholder="统一信用代码"></Input>
        </Col>
        <Col span="12" :lg="12" :md="24" :sm="24" :xs="24" class="page-action">
          <div>
            <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
            <Button icon="ios-reset" @click="reset()">清空</Button>
          </div>
        </Col>
      </Row>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-update="handleChange"></sl-table>
    </div>
  </sl-page>
</template>
<script>

const columns_ = [
  {
    title: '被授信人名称',
    key: 'displayName'
  },
  {
    title: '被授信人编码',
    key: 'displayCode'
  },
  {
    title: '授信公司',
    key: 'creditCompanyName'
  },
  {
    title: '订单编号',
    key: 'orderNo'
  },
  {
    title: '审批状态',
    key: 'stateText'
  },
  {
    title: '创建时间',
    key: 'createDatetimeText'
  }
]


export default {
  data() {
    return {
      columns: [
        ...columns_,
        {
          title: '操作',
          key: 'action',
          width: 80,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('a', {
                props: {
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.copy(params)
                  }
                }
              }, '复制')
            ])
          }
        }
      ],
      data: [],
      params: {
        name: null,
        code: null
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false
    }
  },

  created() {
    this.def = { ...this.params }
    this.list()
  },

  methods: {

    list() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.ciHistories(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          // this.data = this.$utils.conv(resp.data.list || [], { 'createDatetime': 'time' , 'enterpriseType':'$enterpriseType', 'companyType':'$companyType','state':'$state'})
          this.data = this.$utils.merge(this.$utils.conv(resp.data.list || [], { 'createDatetime': 'time' , 'state':'$loanState', 'companyType':'$companyType'}),{'enterpriseName':'displayName' , 'personalName':'displayName' , 'enterpriseCode':'displayCode','personalCode':'displayCode'})

          this.page.total = resp.data.total || 0
        }
      })
    },


    reset() {
      this.$utils.fill(this.params, this.def)
      this.list()
    },
    copy({row}){
      this.$ui.confirm(this.$request.ciCopy, `确定复制 ${row.displayName} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.list()
        }
      })
    },
    handleChange(pageNum , pageSize ){
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    }
  }
}

</script>